import { cygnusIconElement } from '@root/services/cygnusIconMarkup';

// Formerly fontAwesomeIcon.js — cell.getValue() supplies { colour, class },
// where `class` used to be a raw FA class string (e.g. 'fa-heart'). Routed
// through cygnusIconElement's resolveIconName so any existing caller's
// value keeps resolving to the equivalent Cygnus glyph.
export default function (cell) {
  if (cell.getValue() === null) {
    return '';
  }
  const {colour = 'inherit', class: cls = ''} = cell.getValue();

  const icon = cygnusIconElement(cls.trim());
  icon.style.color = colour;

  return icon;
}
